module.exports = __webpack_public_path__ + "img/porta-tr.e00243e8.png";